const translations = {
  "notifications.passwordChanged": "Password changed successfully!",
  "notifications.passwordCouldntChange": "Failed to change the password",
  "notifications.passwordIsWrong": "User password is incorrect",
  "notifications.consultationDeleted": "Consultation deleted successfully",
  "notifications.consultationCouldntBeDeleted":
    "Consultation could not be canceled",
  "notifications.couldntFindActivePolicy":
    "Unfortunately, no active policy was found with the mentioned personal number",
  "notifications.wrongInsuranceNumber": "Insurer's personal number is invalid",
  "notifications.couldntGetInfo": "Failed to retrieve information",
  "notifications.inputCorrectPNOrBdate":
    "Please enter the correct Personal Number/Date of Birth",
  "notifications.wrongUserName": "Password/Username is not correct",
  "notifications.successfullyCanceled": "Consultation has been canceled",
  "notifications.couldntCancelConsultation":
    "Consultation could not be canceled",
  "notifications.informationSuccessfullyShared":
    "Information shared successfully",
  "notifications.couldntshareDetails": "Information couldn't be shared",
  "notifications.verificationCodeIsWrong": "The verification code is invalid",
  "notifications.sesssionExpired":
    "The session has expired, please return to the SMS authentication stage",
  "notifications.phoneChangedSuccessfully": "mobile has changed successfully",
  "notifications.couldntRegister":
    "We are sorry, registration is currently not possible",
};

export default translations;
